// removed by extract-text-webpack-plugin
module.exports = {"sortable-item":"_3s6qWE0eITiTMumu-how7p","drag-handle":"_3KH9haWilHwLR7BcP4LEP2","spin":"_2AxPOdSoyvAUJqh1tsKsbM"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/SortableList/styles.scss
// module id = 905
// module chunks = 18